/**
 * Tracking delle CTA → dataLayer (eventi GA4-nativi).
 * Vedi docs/piani/tracking-gtm.md.
 *
 * Un solo listener delegato sul document: legge gli attributi data-tm-* stampati
 * dall'helper PHP tm_track_attr() e fa push su window.dataLayer. La logica di
 * mappatura azione → evento GA4 vive solo qui; il markup resta neutro.
 */

// Azione (data-tm-action) → evento GA4. 'maps' non ha un nativo: nome custom.
const EVENT_BY_ACTION = {
	book: 'begin_checkout',
	call: 'generate_lead',
	email: 'generate_lead',
	whatsapp: 'generate_lead',
	maps: 'get_directions',
};

// Per generate_lead: normalizza l'azione nel parametro lead_method GA4.
const LEAD_METHOD = { call: 'phone', email: 'email', whatsapp: 'whatsapp' };

/**
 * Costruisce l'array items GA4 dal contesto offerta, se un antenato lo espone
 * (data-tm-offer-*). Ritorna { items, value? } oppure {} se non in contesto offerta.
 */
function offerContext( el ) {
	const ctx = el.closest( '[data-tm-offer-id]' );
	if ( ! ctx ) {
		return {};
	}

	const item = {
		item_id: ctx.dataset.tmOfferId,
		item_name: ctx.dataset.tmOfferName || '',
		item_category: 'offerta',
		quantity: 1,
	};

	const price = parseFloat( String( ctx.dataset.tmOfferPrice || '' ).replace( ',', '.' ) );
	if ( ! Number.isNaN( price ) ) {
		item.price = price;
	}

	const out = { items: [ item ] };
	if ( ! Number.isNaN( price ) ) {
		out.value = price;
	}
	return out;
}

function handleClick( e ) {
	const el = e.target.closest( '[data-tm-track="cta"]' );
	if ( ! el ) {
		return;
	}

	const action = el.dataset.tmAction;
	const event = EVENT_BY_ACTION[ action ];
	if ( ! event ) {
		return;
	}

	const payload = { event, cta_location: el.dataset.tmLocation || '' };

	if ( 'book' === action ) {
		const ctx = offerContext( el );
		Object.assign( payload, ctx );
		// GA4 raccomanda currency ogni volta che si inviano items (value solo col prezzo).
		if ( ctx.items ) {
			payload.currency = 'EUR';
		}
	} else if ( 'maps' !== action ) {
		payload.lead_method = LEAD_METHOD[ action ] || action;
	}

	window.dataLayer.push( payload );
}

export function initTracking() {
	// Garantisce la coda anche senza GTM: gli eventi non si perdono, restano innocui.
	window.dataLayer = window.dataLayer || [];
	document.addEventListener( 'click', handleClick );
}
